var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaregiving(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "black",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11058_32089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0249 27.7148C35.0249 29.4237 33.6377 30.8086 31.9274 30.8086C30.2189 30.8086 28.834 29.4233 28.834 27.7148C28.834 26.0063 30.2189 24.6211 31.9274 24.6211C33.6377 24.6211 35.0249 26.0063 35.0249 27.7148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9328 20.1973C30.5011 20.1973 28.5012 20.768 27.0526 22.2166L28.7731 25.3513C29.1491 24.8728 29.6289 24.4861 30.1763 24.2204C30.7237 23.9547 31.3244 23.8169 31.9328 23.8175C33.23 23.8175 34.3842 24.4303 35.1196 25.3831L36.8071 22.1446C35.5535 20.7748 33.3053 20.1973 31.9328 20.1973ZM33.2078 22.499H32.4068V23.2993H31.4446V22.499H30.6436V21.5371H31.4446V20.7335H32.4068V21.5371H33.2078V22.499ZM27.8626 36.3699H28.655L27.5232 40.2489H36.3661L35.2396 36.3699H36.0327L37.1663 40.2489H39.7685L37.9925 34.3719C37.715 33.4018 36.4985 31.6936 34.3992 31.6419L29.573 31.6378C27.4261 31.6483 26.1841 33.3898 25.9032 34.3715L24.0927 40.2485H26.7316L27.8626 36.3699ZM20.3555 41.4856H43.5042V43.688H20.3555V41.4856Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11058_32089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(20 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiving);
export default __webpack_public_path__ + "static/media/caregiving.b3fa29bc11d1060fd7e35220ef85bb4c.svg";
export { ForwardRef as ReactComponent };